import { FieldType, FederalPublicationInfoField } from '../../../components/GenericSection/constants';
import { ADVANCED_INFO, PUBICATION_INFO, SOURCE, VOLUME, YEAR_PUBLISHED } from '../../constants';

/** field list for publication federal info section */
export var PUB_FEDERAL_INFO_SECTION_FIELD_LIST = [{
  field: FederalPublicationInfoField.YEAR,
  labelText: YEAR_PUBLISHED,
  recommended: true,
  type: FieldType.TEXT
}, {
  field: FederalPublicationInfoField.SOURCE,
  labelText: ADVANCED_INFO,
  helperText: SOURCE,
  recommended: true,
  type: FieldType.TEXT
}, {
  field: FederalPublicationInfoField.VOLUME,
  labelText: PUBICATION_INFO,
  helperText: VOLUME,
  recommended: true,
  type: FieldType.TEXT
}];